import ContactUsContainer from "../components/pageComponents/ContactUs/ContactUsContainer";

const ContactUs  = () => {
    return (<div><ContactUsContainer /></div>);
}

export default ContactUs;